<script setup>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import { Mail } from 'lucide-vue-next';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/Components/ui/card';
import { Button } from '@/Components/ui/button';
import { Input } from '@/Components/ui/input';
import { Label } from '@/Components/ui/label';

defineProps({
    status: String,
});

const form = useForm({
    email: '',
});

const submit = () => {
    form.post(route('password.email'));
};
</script>

<template>
    <Head title="Quên mật khẩu" />

    <div class="flex min-h-screen items-center justify-center bg-muted px-4 py-12">
        <Card class="w-full max-w-md">
            <CardHeader class="space-y-2 text-center">
                <CardTitle class="text-3xl">
                    <span class="font-bold">Đông Tây</span> ERP
                </CardTitle>
                <CardDescription>Nhập email để nhận link lấy lại mật khẩu</CardDescription>
            </CardHeader>

            <CardContent>
                <div v-if="status" class="mb-4 rounded-md bg-green-50 px-3 py-2 text-center text-sm font-medium text-green-700">
                    {{ status }}
                </div>

                <JetValidationErrors class="mb-4" />

                <form class="space-y-4" @submit.prevent="submit">
                    <div class="space-y-2">
                        <Label for="email">Email</Label>
                        <div class="relative">
                            <Mail class="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                            <Input
                                id="email"
                                v-model="form.email"
                                type="email"
                                class="pl-10"
                                placeholder="email@dongtay.vn"
                                required
                                autofocus
                            />
                        </div>
                    </div>

                    <Button
                        type="submit"
                        class="w-full"
                        :class="{ 'opacity-50': form.processing }"
                        :disabled="form.processing"
                    >
                        Gửi link lấy lại mật khẩu
                    </Button>
                </form>

                <div class="mt-6 text-center text-sm text-muted-foreground">
                    <Link :href="route('login')" class="text-primary hover:underline">Quay lại đăng nhập</Link>
                </div>
            </CardContent>
        </Card>
    </div>
</template>
